import type { ComponentType } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import LoadingSpinner from "@/presentation/components/shared/LoadingSpinner";

export function withAuthGuard<P extends object>(Component: ComponentType<P>) {
  return withAuthenticationRequired(Component, {
    loginOptions: {
      authorizationParams: {
        screen_hint: "login",
      },
    },
    onRedirecting: () => <LoadingSpinner />,
  });
}
